module.exports = __webpack_public_path__ + "static/media/65_tn.c2c9d32f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/65_tn.jpg
// module id = 552
// module chunks = 0